import { Path } from '../../models'

import { isSamePath } from './isSamePath'

export const isServicesPath = isSamePath(Path.Services)
